/*
 存放系统方法
*/
import Cookies from 'js-cookie';
import { appId, redirectUrl } from './commonVariables';

const getToken = function() {
  // 从cookie中获取token
  return localStorage.getItem('ticket_wdsx');
  //return '7798BAEF5A840154E3485BCE0A4D3B80'
};
//跳转到鉴权页面
const gotoOAuth = function () {
  window.location.href=`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect`
}

//是否禁用
const ifDisable = function () {
  return localStorage.getItem('ifDisable');
}
//是否綁定手機號
const ifBindPhone = function () {
  return localStorage.getItem('ifBindPhone')
}

export {
  getToken,
  gotoOAuth,
  ifBindPhone,
  ifDisable
}